export default {
	exhibit: null,
	loading: false,
	errored: false,
	exhibitNotFound: false,
	selectedRecord: null,
	previewedRecord: null,
	editorRecord: null,
	editorNewRecord: false,
	tabIndex: 0,
	showExhibitSettings: true,
	recordEditorType: '',
	showRecords: true,
};



// WEBPACK FOOTER //
// ./src/reducers/exhibit/exhibitShow-initialState.js